import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useFocused } from "../hooks/useFocused";
import { colorNameMap } from "../../colorNameMap";
import { eramFontDimensionMap, eramFontNameMap, getBitmapTextStyles } from "../../eramFont";
import { useReplayContext, MIN_REPLAY_SPEED, MAX_REPLAY_SPEED } from "../contexts/replayContext";
import { useWindowSize } from "usehooks-ts";
import { TBE, TBP } from "../../buttons";
import { errorTone } from "../../audio/errorTone";
const fontFamily = eramFontNameMap[2];
const fontDim = eramFontDimensionMap[fontFamily];
const tint = colorNameMap.lightGrey;
const buttonSize = fontDim.height;
const Play = () => {
    return (_jsx("graphics", { eventMode: "none", x: 2, y: 2, draw: (graphics) => {
            graphics.clear();
            // TODO: use polygon
            graphics.moveTo(0, 0);
            graphics.lineTo(0, buttonSize - 3);
            graphics.lineTo(buttonSize - 3, (buttonSize - 3) / 2);
            graphics.lineTo(0, 0);
            graphics.fill(0xadadad);
        } }));
};
const Pause = () => {
    return (_jsx("graphics", { eventMode: "none", x: 3, y: 3, draw: (graphics) => {
            graphics.clear();
            graphics.rect(0, 0, 3, buttonSize - 5).fill(0xadadad);
            graphics.rect(7, 0, 3, buttonSize - 5).fill(0xadadad);
        } }));
};
const Stop = () => {
    return (_jsx("graphics", { eventMode: "none", x: 3, y: 4, draw: (graphics) => {
            graphics.clear();
            graphics.rect(0, 0, buttonSize - 7, buttonSize - 7).fill(0xadadad);
        } }));
};
const ReplayButton = ({ onmousedown, children, width = buttonSize, x = 0, y = 0 }) => {
    const ref = React.useRef(null);
    const focused = useFocused(ref);
    return (_jsxs("container", { x: x, y: y, eventMode: "static", onMouseDown: onmousedown, sortableChildren: true, children: [_jsx("graphics", { zIndex: 0, ref: ref, eventMode: "static", draw: (graphics) => {
                    graphics.clear();
                    graphics.setStrokeStyle({ width: 1, color: focused ? colorNameMap.lightGrey : colorNameMap.darkGrey });
                    graphics.rect(0, 0, width, buttonSize).fill(0);
                } }), _jsx("container", { zIndex: 1, children: children })] }));
};
const speedControlWidth = fontDim.width * 7;
const SpeedControl = ({ x = 0, y = 0 }) => {
    const replayState = useReplayContext();
    return (_jsx(ReplayButton, { x: x, y: y, width: speedControlWidth, onmousedown: (event) => {
            if (event.button === TBP) {
                if (replayState.speedMultiplier > MIN_REPLAY_SPEED) {
                    // replayManager.speedMultiplier = replayState.speedMultiplier / 2;
                }
                else {
                    errorTone.tryPlay();
                }
            }
            else if (event.button === TBE) {
                if (replayState.speedMultiplier < MAX_REPLAY_SPEED) {
                    // replayManager.speedMultiplier = replayState.speedMultiplier * 2;
                }
                else {
                    errorTone.tryPlay();
                }
            }
        }, children: _jsx("bitmapText", { x: Math.floor(speedControlWidth / 2), y: 1, eventMode: "none", text: replayState.speedMultiplier.toFixed(3).replace(/\.?0+$/, "") + "X", roundPixels: true, anchor: { x: 0.5, y: 0 }, style: { ...getBitmapTextStyles(fontFamily), fill: tint } }) }));
};
export const ReplayControl = ({ zIndex, x: _x, y = 1 }) => {
    const replayState = useReplayContext();
    const windowSize = useWindowSize();
    const x = _x ?? Math.max(0, Math.floor((windowSize.width + 1 - (buttonSize + 3) * 2) / 2));
    return (_jsxs("container", { x: x, y: y, zIndex: zIndex, children: [_jsx(ReplayButton, { x: buttonSize + 2, onmousedown: () => {
                    if (replayState.status !== "playing") {
                        if (replayState.status !== "paused") {
                            // replayManager.start();
                        }
                        else {
                            // replayManager.continue();
                        }
                    }
                    else {
                        // replayManager.pause();
                    }
                }, children: replayState.status === "playing" ? _jsx(Pause, {}) : _jsx(Play, {}) }), _jsx(ReplayButton, { x: (buttonSize + 2) * 2, onmousedown: () => {
                    // replayManager.stop();
                }, children: _jsx(Stop, {}) }), _jsx(SpeedControl, { x: (buttonSize + 2) * 3 })] }));
};
//# sourceMappingURL=ReplayControl.js.map